document.addEventListener('DOMContentLoaded', function () {
  const picker = document.getElementById('variant-picker');
  const productId = picker?.dataset.productId;

  const hiddenInput = document.getElementById('selected-variant-id');
  const addToCartBtn = document.querySelector('[data-submit-btn]');
  const qtyInput = document.querySelector('[data-qty-value]');
  const qtyPlus = document.querySelector('[data-qty-plus]');
  const qtyMinus = document.querySelector('[data-qty-minus]');
  const syncQtyInput = document.getElementById('quantity');

  // Read JSON safely from <script> tag
  const variantScript = document.getElementById('variant-data');
  let variants = [];
  if (variantScript) {
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (err) {
      console.error('Invalid JSON in variant-data', err);
      return;
    }
  }

  const optionsCount = parseInt(picker?.dataset.optionsCount) || 0;
  const selectedOptions = new Array(optionsCount).fill(null);
  let maxQty = 1;

  function getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    return variantId ? parseInt(variantId) : null;
  }

  function applyVariantOptions(variantObj) {
    if (!variantObj) return;
    variantObj.options.forEach((opt, i) => {
      selectedOptions[i] = opt;
    });
    updateUI();
    updateSelectedVariant();
  }

  function initVariantSelection() {
    const variantIdFromURL = getVariantFromURL();
    let variantToSelect = null;

    if (variantIdFromURL) {
      variantToSelect = variants.find(v => v.id === variantIdFromURL);
    }
    if (!variantToSelect) {
      variantToSelect = variants.find(v => v.available);
    }

    applyVariantOptions(variantToSelect);
  }

  function updateSelectedVariant() {
    const matchedVariant = variants.find(variant =>
      variant.options.every((opt, i) => selectedOptions[i] === opt)
    );

    if (matchedVariant) {
      if (hiddenInput) hiddenInput.value = matchedVariant.id;

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", matchedVariant.id);
      window.history.replaceState({}, '', newUrl);

      updateAddToCartState(matchedVariant);
      updateQtyMaxFromVariant(matchedVariant);
      updatePriceSection(matchedVariant);

      // ---------- Thumbnail -> slide index (use last match) ----------
      const variantIdStr = String(matchedVariant.id);
      const allThumbs = document.querySelectorAll('.thumb-slider .swiper-slide[data-variant-thumb-id]');
      let chosenThumb = null;
      let chosenIndex = -1;

      allThumbs.forEach((thumb) => {
        const idsAttr = thumb.getAttribute('data-variant-thumb-id') || '';
        const ids = idsAttr.split(',').map(s => s.trim()).filter(Boolean);
        if (ids.includes(variantIdStr)) {
          // Compute index from aria-label "X / Y" => index = X - 1
          let idx = -1;
          const aria = thumb.getAttribute('aria-label'); // e.g. "7 / 24"
          if (aria) {
            const m = aria.match(/^\s*(\d+)\s*\/\s*\d+\s*$/);
            if (m) idx = parseInt(m[1], 10) - 1;
          }
          // Fallback to DOM order if aria-label missing
          if (idx < 0) {
            idx = Array.prototype.indexOf.call(allThumbs, thumb);
          }
          // Keep the LAST matched thumb as requested
          chosenThumb = thumb;
          chosenIndex = idx;
        }
      });

      if (chosenThumb && chosenIndex >= 0) {
        console.log('✅ Thumbnail FOUND for variant', variantIdStr, '-> index', chosenIndex);

        // Move thumb slider
        try {
          if (typeof thumbSlider !== 'undefined') {
            if (typeof thumbSlider.slideToLoop === 'function') {
              thumbSlider.slideToLoop(chosenIndex);
            } else {
              thumbSlider.slideTo(chosenIndex);
            }
            console.log('➡️ thumbSlider moved to index', chosenIndex);
          }
        } catch (e) {
          console.log('⚠️ thumbSlider move error:', e);
        }

        // Move main slider
        try {
          if (typeof mainSlider !== 'undefined') {
            if (typeof mainSlider.slideToLoop === 'function') {
              mainSlider.slideToLoop(chosenIndex);
            } else {
              mainSlider.slideTo(chosenIndex);
            }
            console.log('➡️ mainSlider moved to index', chosenIndex);
          }
        } catch (e) {
          console.log('⚠️ mainSlider move error:', e);
        }

        // Also click the thumb (for any theme-side handlers)
        try {
          chosenThumb.click();
          console.log('🖱️ Clicked matched thumbnail element');
        } catch (e) {
          console.log('⚠️ Click on thumbnail failed:', e);
        }
      } else {
        console.log('❌ No thumbnail FOUND for variant', variantIdStr);
      }

    } else {
      if (hiddenInput) hiddenInput.value = '';
      disableAddToCart();
      updateQtyMaxFromVariant(null);
    }
  }



  // Format helpers
  function formatMoney(amount) {
    return `$${(amount / 100).toFixed(2)}`;
  }

  function updatePriceSection(variant) {
    const priceWrapper = document.querySelector(`#pdp-price-wrapper-${productId}`);
    if (!priceWrapper) return;

    let html = '';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      html = `
        <span class="pdp__price font-bold">${formatMoney(variant.price)}</span>
        <s class="pdp__compare-price font-regular">${formatMoney(variant.compare_at_price)}</s>
        <span class="pdp__saving-badge font-bold">${discount}% Off</span>
      `;
    } else {
      html = `<span>${formatMoney(variant.price)}</span>`;
    }

    priceWrapper.innerHTML = html;
  }

  function updateAddToCartState(variant) {
    if (variant.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('btn--disabled');
      addToCartBtn.textContent = addToCartBtn.getAttribute('data-default-label') || 'Add to Cart';
    } else {
      disableAddToCart();
    }
  }

  function disableAddToCart() {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('btn--disabled');
    addToCartBtn.textContent = addToCartBtn.getAttribute('data-sold-out-label') || 'Sold Out';
  }

  function updateUI() {
    picker.querySelectorAll('[data-value]').forEach(btn => {
      btn.classList.remove('pdp__option-value--selected');
    });

    picker.querySelectorAll('[data-options]').forEach((group, i) => {
      const selectedVal = selectedOptions[i];
      if (selectedVal) {
        const escapedVal = CSS.escape(selectedVal);
        const selectedBtn = group.querySelector(`[data-value="${escapedVal}"]`);
        if (selectedBtn) selectedBtn.classList.add('pdp__option-value--selected');
      }
    });
  }

  picker.querySelectorAll('[data-options]').forEach((group, index) => {
    group.addEventListener('click', e => {
      const btn = e.target.closest('[data-value]');
      if (!btn || btn.disabled) return;
      selectedOptions[index] = btn.dataset.value;
      updateUI();
      updateSelectedVariant();
    });
  });

  // Quantity Management
  function updateQtyMaxFromVariant(variant) {
    if (variant && variant.available) {
      maxQty = variant.inventory_quantity || 999;
    } else {
      maxQty = 1;
    }
    const currentVal = parseInt(qtyInput.value) || 1;
    if (currentVal > maxQty) qtyInput.value = maxQty;
    updateQtyState();
  }

  function updateQtyState() {
    const val = parseInt(qtyInput.value) || 1;
    qtyMinus.disabled = val <= 1;
    qtyPlus.disabled = val >= maxQty;
    if (syncQtyInput) syncQtyInput.value = val;
  }

  qtyPlus?.addEventListener('click', () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val < maxQty) {
      qtyInput.value = val + 1;
      updateQtyState();
    }
  });

  qtyMinus?.addEventListener('click', () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val > 1) {
      qtyInput.value = val - 1;
      updateQtyState();
    }
  });

  qtyInput?.addEventListener('input', () => {
    let val = parseInt(qtyInput.value);
    if (isNaN(val) || val < 1) val = 1;
    if (val > maxQty) val = maxQty;
    qtyInput.value = val;
    updateQtyState();
  });

  // Init
  initVariantSelection();
});
